export function coerceNot<T>(val: T, not: T | null = null): T | null {
  if (!val) {
    return not;
  }
  if (Array.isArray(val) && val.length === 0) {
    return not;
  }
  return val;
}
